import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import SkeletonPattern from '@mlb/react-patterns/components/Skeleton/skeleton.tsx';

import Player from './Player';
import ImgFallback from './ImgFallback';

const Skeleton = styled(SkeletonPattern).attrs({
    borderRadius: '0',
    margin: '0',
    height: '0',
})`
    padding-bottom: 56.25%;
`;

const FeaturedVideo = (props) => {

    const {
        data,
        mediaItem,
        loading,
        isEU,
        isPlaybackReady,
    } = props;

    const [
        showSkeleton,
        setShowSkeleton,
    ] = useState(true);

    const hideSkeleton = useCallback(() => setShowSkeleton(false), [setShowSkeleton]);

    return (
        <Skeleton isLoading={showSkeleton}>
            {(!loading && isPlaybackReady) && (
                Object.keys(mediaItem).length > 0 ? (
                    <Player
                        mediaItem={mediaItem}
                        isEU={isEU}
                        onReadyToPlay={hideSkeleton}
                    />
                ) : (
                    <ImgFallback
                        data={data}
                        onImgLoaded={hideSkeleton}
                    />
                )
            )}
        </Skeleton>
    );

};

FeaturedVideo.propTypes = {
    isPlaybackReady: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    mediaItem: PropTypes.object.isRequired,
    data: PropTypes.object,
    isEU: PropTypes.bool,
};

FeaturedVideo.defaultProps = {
    data: {},
    isEU: false,
};

export default FeaturedVideo;
